const tabbedContent = () => {
    const tabbedContentSections = document.querySelectorAll('[data-tabbed-content]');
    tabbedContentSections.forEach((section) => {
        const tabTitlesContainer = section.querySelector('[data-headings-container]');
        const tabTitles = tabTitlesContainer.querySelectorAll('[data-tab-title-id]');
        const indicator = tabTitlesContainer.querySelector('[data-tab-indicator]');
        const contentContainer = section.querySelector('[data-content-container]');
        const openTab = (tabID) => {
            const title = section.querySelector('[data-tab-title-id="' + tabID + '"]');
            const content = section.querySelector('[data-tab-content-id="' + tabID + '"]');
            title.classList.add('tab-heading--active');
            content.classList.add('tab-content--active');
            content.style.maxHeight = content.scrollHeight + 'px';
            contentContainer.style.height = content.scrollHeight + 'px';
        };
        const closeTab = (tabID) => {
            const title = section.querySelector('[data-tab-title-id="' + tabID + '"]');
            const content = section.querySelector('[data-tab-content-id="' + tabID + '"]');
            title.classList.remove('tab-heading--active');
            content.classList.remove('tab-content--active');
            content.style.maxHeight = null;
        };
        tabTitles.forEach((tab) => {
            tab.addEventListener('mouseover', () => {
                const width = tab.offsetWidth;
                const left = tab.offsetLeft;
                indicator.style.setProperty('--left', left + 'px');
                indicator.style.setProperty('--width', width + 'px');
            });
            tab.addEventListener('mouseout', () => {
                const activeTab = section.querySelector('.tab-heading--active');
                const width = activeTab.offsetWidth;
                const left = activeTab.offsetLeft;
                indicator.style.setProperty('--left', left + 'px');
                indicator.style.setProperty('--width', width + 'px');
            });
            tab.addEventListener('click', () => {
                const tabID = tab.getAttribute('data-tab-title-id');
                const content = section.querySelector('[data-tab-content-id="' + tabID + '"]');
                const offsetLeft = tab.offsetLeft;
                const tabWidth = tab.offsetWidth;
                const containerWidth = tabTitlesContainer.offsetWidth;
                let extraSpace = containerWidth - tabWidth;
                extraSpace = extraSpace / 2;
                tabTitlesContainer.scrollLeft = offsetLeft - extraSpace;
                if (content.style.maxHeight) {
                    closeTab(tabID);
                }
                else {
                    tabTitles.forEach((tab) => {
                        const tabID = tab.getAttribute('data-tab-title-id');
                        closeTab(tabID);
                    });
                    openTab(tabID);
                }
            });
        });
        window.addEventListener('load', () => {
            const activeTab = section.querySelector('.tab-heading--active');
            const activeContent = section.querySelector('.tab-content--active');
            const width = activeTab.offsetWidth;
            const left = activeTab.offsetLeft;
            indicator.style.setProperty('--left', left + 'px');
            indicator.style.setProperty('--width', width + 'px');
            contentContainer.style.height = activeContent.scrollHeight + 'px';
            if (activeContent.hasAttribute('open-on-load')) {
                activeContent.style.maxHeight = activeContent.scrollHeight + 'px';
            }
        });
    });
};
export { tabbedContent };
